import { useController } from '../../hooks/useController'
import { ErrorCard } from './components/ErrorCard'
import { InfoCard } from './components/InfoCard'

export function Body() {
  const ctrl = useController()

  return ctrl.data.issue === 'none' ? <InfoCard /> : <ErrorCard />
}
